import React from "react";
import { useNavigate } from "react-router-dom";
import { Photo, User, Session } from "../../types/Types";
import UserTag from "../../users/tag/UserTag";
import LocationTag from "../../tag/LocationTag";
import TruncatedPhotoTags from "../../tag/TruncatedPhotoTags";
import CommentTag from "../../tag/CommentTag";
import DateTime from "../../date/DateTime";
import { getDateFromTimeStamp } from "../../util/Util";
import { Link } from "react-router-dom";

interface Props {
    photo: Photo;
    usersMap: Map<string, User>;
    sessionsMap: Map<string, Session>;
    notificationLimit: number;
}

const PhotoAddedRow: React.FC<Props> = ({ photo, usersMap, sessionsMap, notificationLimit }) => {
    const navigate = useNavigate();
    const isCheckedIn = (userId: string): boolean => {
        const session = sessionsMap.get(userId);
        return (session && getDateFromTimeStamp(session.checkOutTime) > new Date()) || false;
    };

    return (
        <>
            <div key={photo.id} className={"news-item"}>
                <div className={"d-inline-block"}>
                    <div className={"d-inline-block"}>
                        <UserTag 
                            user={usersMap.get(photo.userId)} 
                            visit={undefined} 
                            session={sessionsMap.get(photo.userId)} 
                            padRight={false} 
                            hideLocationDot={false} 
                            linksToTab={"photos"}
                        />
                    </div>
                    <div className={"d-inline-block mr-1"}>
                        added a
                    </div>
                    <div className={"d-inline-block mr-1"}>
                        <Link to={`/photo/${photo.id}`}>
                            <div className={`user-tag d-inline-block`}>
                                <span>photo</span>
                            </div>
                        </Link>
                    </div>
                    <div className={"d-inline-block mr-1"}>
                        to
                    </div>
                    <LocationTag 
                        name={photo.locationName} 
                        id={photo.locationId} 
                        session={sessionsMap.get(photo.userId)} 
                        displayVerificationTag={isCheckedIn(photo.userId)} 
                        linksToTab={"photos"} 
                    />
                    {(photo.description || photo.tags.length > 0) && (
                        <div className={`d-inline-block mr-1 ${isCheckedIn(photo.userId) ? 'ml-1' : ''}`}>
                            tagged with
                        </div>
                    )}
                    {photo.description && (
                        <div className={"d-inline-block mr-1"}>
                            <CommentTag onClick={() => navigate(`/photo/${photo.id}`)} />
                        </div>
                    )}
                    <TruncatedPhotoTags tags={photo.tags} count={0} bold={false} charLimit={12} />
                </div>
                <DateTime date={photo.createdAt}/>
            </div>
        </>
    );
};

export default PhotoAddedRow;
